/**
 * AppealContentReportSheet
 *
 * Helper to show the Appeal Content Report sheet using SheetService.
 * Mirrors Flutter's ContentReportAppealScreen
 * (lib/presentation/screens/content/content_report_appeal_screen.dart),
 * surfaced via NavigationService.navigateToContentReportAppealScreen
 * from ContentActionsBottomSheet.onAppealContent.
 *
 * Resolves with `true` when the appeal was successfully submitted.
 */

import React from 'react';
import { SheetService } from '@/presentation/components/common/sheet/service/SheetService.index';
import { AppealContentReportContent } from './components/AppealContentReportContent';

export interface AppealContentReportSheetConfig {
  contentId: string;
  container?: HTMLElement | string | null;
  screenKey?: string;
  fixedHeight?: string;
}

const show = (config: AppealContentReportSheetConfig): Promise<boolean> => {
  return new Promise((resolve) => {
    let resolved = false;

    const finishWith = (submitted: boolean) => {
      if (!resolved) {
        resolved = true;
        resolve(submitted);
        SheetService.close();
      }
    };

    const SheetContent: React.FC = () => (
      <AppealContentReportContent
        contentId={config.contentId}
        onFinish={(submitted) => finishWith(submitted)}
      />
    );

    SheetService.show({
      content: <SheetContent />,
      container: config.container,
      screenKey: config.screenKey,
      fixedHeight: config.fixedHeight,
      dismissible: false,
      closeOnClickOutside: false,
      scrollable: false,
      onClose: () => {
        if (!resolved) {
          resolved = true;
          resolve(false);
        }
      },
    });
  });
};

export const AppealContentReportSheet = {
  show,
};
